module.exports = __webpack_public_path__ + "img/35-1.f0ade54e.jpg";